import { render, staticRenderFns } from "./configshu.vue?vue&type=template&id=8565356a&"
import script from "./configshu.vue?vue&type=script&lang=js&"
export * from "./configshu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports